(() => {
    "use strict";

    angular.module("app").factory("ScreeningFunctions", ScreeningFunctionsFactory);
    
    ScreeningFunctionsFactory.$inject = ["HabilNavigator", "enumService"];
    function ScreeningFunctionsFactory(HabilNavigator, enumService) {
        function openScreening(screening) {
            const parameters = `?screeningId=${screening.PublicId}&DT=${new Date().toISOString()}`;
            const page = getPageByTypeCode(screening.TypeCode);

            HabilNavigator.OpenByIdAndRoute(screening.PublicId, `${page}${parameters}`);
        };

        function getPageByTypeCode(typeCode) {
            if (!typeCode) return;

            switch (typeCode) {
                case enumService.ScreeningTypeCode.FVM:
                    return `Screenings/FVMRequest/`;
                case enumService.ScreeningTypeCode.IVM:
                case enumService.ScreeningTypeCode.CertificateOut:
                case enumService.ScreeningTypeCode.SecurityCheck:
                    return `Screenings/IVMRequest/`;
            }
        }

        return {
            OpenScreening: openScreening
        };
    }
})();